var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ahCnter"},[_c('img',{attrs:{"src":require("static/images/developing.png"),"alt":"开发中"}}),_vm._v(" "),_c('p',{staticClass:"text-center tips"},[_vm._v(_vm._s(_vm.desc))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-036032aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pending/Pending.vue
// module id = null
// module chunks = 